export const ERROR_CLASS_TRANSPORT = 'ERROR_CLASS_TRANSPORT';
export const ERROR_CLASS_FROM_API = 'ERROR_CLASS_FROM_API';
